import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useQuery } from '@apollo/client'
import { Button } from '../../components/common'
import { CircleErrorIcon, GlobalLoader } from '../../theme/icons'
import ErrorBoundary from '../../components/Errorboundary'
import { GET_LOGIN_METHOD } from '../../grapghQl/queries/auth'

const SAML_ERROR_CODES = [
    'SAML-000',
    'SAML-001',
    'SAML-002',
    'SAML-003',
    'SAML-004',
    'SAML-005',
    'SAML-006',
    'SAML-007',
    'SAML-008',
]

const SAML_SSO_RETRY_ERROR_CODES = [
    'SAML-000',
    'SAML-001',
    'SAML-002',
    'SAML-003',
    'SAML-005',
]

const SAML_BOTH_BACK_TO_LOGIN_ERROR_CODES = [
    'SAML-000',
    'SAML-001',
    'SAML-002',
    'SAML-003',
    'SAML-005',
    'SAML-006',
    'SAML-007',
]

const SamlError = React.memo(() => {
    const navigate = useNavigate()
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const { data: loginMethodData, loading: loginMethodLoading } = useQuery(GET_LOGIN_METHOD)
    const errorCode = searchParams.get('error_code')
    const displayCode = SAML_ERROR_CODES.includes(errorCode) ? errorCode : 'SAML-000'
    const loginMethod = loginMethodData?.getCustomerLoginMethod
    const showTryAgain = loginMethod === 'SSO_ONLY' && SAML_SSO_RETRY_ERROR_CODES.includes(displayCode)
    const showBackToLogin = loginMethod === 'BOTH' && SAML_BOTH_BACK_TO_LOGIN_ERROR_CODES.includes(displayCode)

    if (loginMethodLoading) {
        return (
            <ErrorBoundary>
                <div className="flex h-screen items-center justify-center">
                    <GlobalLoader />
                </div>
            </ErrorBoundary>
        )
    }

    return (
        <ErrorBoundary>
            <div className="flex h-screen text-center items-center justify-center mx-8">
                <div>
                    <div className="flex justify-center"><CircleErrorIcon /></div>
                    <h1 className="font-semibold text-black mt-2">
                        {formatMessage({ id: 'SAML.ERROR.TITLE' }, { code: displayCode })}
                    </h1>
                    <p className="my-3 text-secondary-400">
                        {formatMessage({ id: `SAML.ERROR.${displayCode}` })}
                    </p>
                    {(showTryAgain || showBackToLogin) && (
                        <Button
                            variant="primary"
                            onClick={() => navigate('/login')}
                            text={formatMessage({
                                id: showTryAgain
                                    ? 'SAML.ERROR.TRY_AGAIN.BUTTON'
                                    : 'SAML.ERROR.BACK_TO_LOGIN.BUTTON',
                            })}
                        />
                    )}
                </div>
            </div>
        </ErrorBoundary>
    )
})

export default SamlError
